import { css } from 'styled-components';

const rtlStyles = css`
  // Font settings for Farsi
  font-family: 'Vazirmatn', 'Tahoma', sans-serif;
  
  // Flip icons that indicate direction
  .ant-pagination-prev .anticon,
  .ant-pagination-next .anticon,
  .ant-menu-submenu-arrow,
  .ant-select-arrow,
  .ant-collapse-arrow {
    transform: scaleX(-1);
  }
  
  // Adjust margins for RTL
  .ant-btn > .anticon + span,
  .ant-btn > span + .anticon {
    margin-right: 8px;
    margin-left: 0;
  }
  
  // Adjust table column alignment
  .ant-table-column-sorter {
    margin-right: 8px;
    margin-left: 0;
  }
  
  // Adjust dropdown alignment
  .ant-dropdown {
    text-align: right;
  }
  
  // Adjust form layout
  .ant-form-item-label {
    text-align: right;
  }
  
  // Adjust modal buttons
  .ant-modal-footer {
    text-align: left;
  }
  
  // Adjust notification positioning
  .ant-notification {
    right: 24px;
    left: auto;
  }
`;

export default rtlStyles;
